(() => {
  function initialize(root = document) {
    root.querySelectorAll('.lp-campaign').forEach(campaign => {
      if (campaign.dataset.ready) return;
      campaign.dataset.ready = 'true';
      const video = campaign.querySelector('video');
      if (!video) return;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)');
      let inView = true;
      video.muted = true;
      const sync = () => {
        if (reducedMotion.matches || document.hidden || !inView) {
          video.pause();
          if (reducedMotion.matches) video.hidden = true;
          return;
        }
        const source = mobile.matches ? video.dataset.filmMobile : video.dataset.filmDesktop;
        if (video.getAttribute('src') !== source) {
          video.hidden = true;
          video.src = source;
        }
        video.play().catch(() => { video.hidden = true; });
      };
      video.addEventListener('playing', () => { video.hidden = false; });
      video.addEventListener('error', () => { video.hidden = true; });
      document.addEventListener('visibilitychange', sync);
      reducedMotion.addEventListener('change', sync);
      mobile.addEventListener('change', sync);
      new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        sync();
      }).observe(campaign);
      sync();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
